import React from 'react';
import { NoticeContentWithUrl } from '@bld/bld-libs/components';
import CommonModal from './Modal';

const SystemNotice = props => {
  const {
    visible,
    onClose,
    message,
    title,
    date,
    loaded,
    buttonText = 'CLOSE',
  } = props;
  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div className='dialog dialog--modal NoticeDialog'>
            {title !== '' && (
              <div className='dialog__header'>
                <span className='dialog__title'>Buildeeからのお知らせ</span>
              </div>
            )}
            <div className='NoticeDialog__body'>
              {loaded ? (
                <div className='NoticeDialog__content'>
                  <div className='NoticeDialog__content-header'>
                    <div className='NoticeDialog__content-header-date'>
                      {date}
                    </div>
                    <div className='NoticeDialog__content-header-title'>
                      {title}
                    </div>
                  </div>
                  <div className='NoticeDialog__content-body'>
                    <NoticeContentWithUrl
                      content={message}
                      urlClassName='clickable-text'
                    />
                  </div>
                </div>
              ) : (
                <div className='indicator' />
              )}
            </div>
            <div className='dialog__footer NoticeDialog__footer'>
              <button
                className='btn--sub'
                onClick={onClose ? onClose : undefined}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};

export default SystemNotice;



// WEBPACK FOOTER //
// ./src/components/modals/common/SystemNotice.jsx